export default "__VITE_ASSET__DCD_3C2D__"